var map = {
	"./Agua.jpg": 616,
	"./Armario.jpg": 617,
	"./Bano.jpg": 374,
	"./Calor.jpg": 1523,
	"./Climatizacion.jpg": 618,
	"./Coche color.jpg": 619,
	"./Cocina.jpg": 620,
	"./Ducha.jpg": 621,
	"./Escaleras.jpg": 1524,
	"./Pared.jpg": 1525,
	"./Puerta de paso.jpg": 622,
	"./Suelo.jpg": 375,
	"./cristalero.jpg": 376,
	"./electricista.jpg": 623,
	"./electrodomesticos.jpg": 377,
	"./jardinero.jpg": 624,
	"./manitas.jpg": 625,
	"./piscina.jpg": 378,
	"./toldos-y-persianas.jpg": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 373;